export default {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.allowUnsort'
        }, 
        sortableMode: {
            type: String,
            default: undefined,
            kComposite: 'sortable.mode'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Sortable.js